import ReactOnRails from 'react-on-rails';
import PhotoAlbumsApp from './appClient';

// This is how react_on_rails can see the HelloWorldApp in the browser.
ReactOnRails.register({ PhotoAlbumsApp });
